<div class="zmodal" [class.zmodal--show]="authService.changeFacilityDialog$ | async">
  <div class="zmodal__wrapper zmodal__wrapper--w100">
    <div class="zmodal__content zmodal__content--half">
      <app-change-facility-screen></app-change-facility-screen>
    </div>
  </div>
</div>
